<template>
  <section id="orders">

    <h2 class="title">{{$t("views.cart.title")}}</h2>
    <div class="desc">{{$t("views.cart.description")}}</div>

    <div class="main-content">
      <h3 class="subtitle">{{$t("views.cart.list")}}</h3>
      <div class="list">
        <div v-for="(item, index) in orders" class="item" :key="item.id">
          <div class="info-order">
            <span>{{item.from.filename}}</span>
            <img class="image" :src="item.from.image" />
          </div>
          <div class="content">

            <div class="to">
              <div v-if="sizes[item.to.file][item.to.filename]" class="name"><span v-if="item.to.file">{{sizes[item.to.file][item.to.filename].name}} </span><span class="print" v-if="item.method == 2">{{$t("views.cart.production")}}</span> </div>
              <div v-if="item.to.size" class="size">{{$t("views.cart.size")}} {{item.to.size}}</div>
            </div>

            <div v-if="item.method == 1">
            </div>
            <div v-else-if="item.method == 2 || item.method == 4">
              <!--<div class="param units">
                <div class="label">Unidades:</div>
                <div class="container">
                  <input v-model.number="item.units" min="1" type="number" class="input" placeholder="Unidades">
                </div>
              </div>-->

              <div class="param units">
                <div class="label">{{$t("general.unit_scale")}}</div>
                <div class="container">
                  <select v-model="item.units_scale" :placeholder="$t('views.cart.scale_placeholder')">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="250 - 500">250 - 500</option>
                    <option value="500 - 1000">500 - 1000</option>
                    <option value="1000 - 2000">1000 - 2000</option>
                    <option value="2000 - 3000">2000 - 3000</option>
                    <option value="3000 - 4000">3000 - 4000</option>
                    <option value="4000 - 5000">4000 - 5000</option>
                    <option value="-1">{{$t("general.personalized")}}</option>
                  </select>
                  <input v-show="item.units_scale == -1" v-model="item.units_scale_custom" type="text" class="units single"> {{$t("general.units")}}
                </div>
              </div>

              <div class="param shipped">
                <div class="label">{{$t("general.send_to")}}</div>
                <div class="container">
                  <select v-model="item.shipped">
                    <option v-for="option in locations" :value="option.id">{{ option.site }} - {{ option.name }} {{ option.cif }} {{ option.razon }}</option>
                    <option value="-1">{{$t("views.cart.other_address")}}</option>
                  </select>
                  <input v-show="item.shipped == -1" v-model="item.custom_ship" type="text" class="address">
                </div>
              </div>
              
            </div>
            <div class="param billed" v-if="market == 'ES'">
              <div class="label">{{$t("general.invoice")}}</div>
              <div class="container">
                <select v-model="item.billed" @change="checkFiscalInfo(item, index)">
                  <option v-for="option in locations" :value="option.id">{{ option.site }} - {{ option.name }} {{ option.cif }} {{ option.razon }}</option>
                </select>
              </div>
            </div>
            <div class="param info" v-if="market == 'PT'">
              <span v-if="item.custom.price">{{ $t("general.price") }} {{ item.custom.price }}€</span>
              <span v-if="item.custom.legal">{{ $t("views.order.customize.legal") }}: {{ item.custom.legal }}</span>
              <span v-if="item.custom.restaurant">{{ $t("general.restaurant") }} {{ item.custom.restaurant }}</span>
              <span v-if="item.custom.others">{{ $t("general.others") }} {{ item.custom.others }}</span>
              <span v-if="item.custom.start_date">{{ $t("general.start_date") }}: {{ formatDate(item.custom.start_date) }}</span>
              <span v-if="item.custom.end_date">{{ $t("general.end_date") }}: {{ formatDate(item.custom.end_date) }}</span>
              <span class="direction" v-if="item.custom.direction && item.custom.direction.text">
                {{ $t("general.direction") }}:                
                <img :src="item.custom.direction.image" />
                {{ item.custom.direction.text }}
              </span>
            </div>
            
          </div>
          <div class="actions">
            <div v-if="item.to.file" class="bttn edit" @click="edit(item)">{{$t("general.edit")}}</div>
            <div class="bttn remove" @click="remove(item)">{{$t("general.delete")}}</div>
          </div>

        </div>
        <div class="empty" v-if="this.$store.getters['orders/getCartLength'] == 0">{{$t("views.cart.empty")}}</div>
        
      </div>

      <h3 class="subtitle">{{$t("general.contact")}}</h3>
      <v-form ref="form_cart" v-model="valid">
        <div class="contact">
          <div class="param">
              <label class="label">{{ $t("general.name") }}:</label>
              <input v-model="contact.name" type="text">
          </div>
          <div class="param">
              <label class="label">{{ $t("general.email") }}:</label>
              <input v-model="contact.email" type="text">
          </div>
          <div class="param">
              <label class="label">{{ $t("general.phone") }}:</label>
              <input v-model="contact.phone" type="text">
          </div>
        </div>
      </v-form>


      <div v-show="error_message" class="message error fadeIn"><span v-html="error_message"></span></div>
      <div v-show="success_message" class="message success fadeIn"><span v-html="$t('views.cart.success')"></span></div>

      <div class="buttons">
        <router-link v-if="$store.state.files.current_category.type == 1" :to="'/nacional/'+$store.state.files.current_category.url" class="bttn">{{$t("views.cart.add_more")}}</router-link>
        <router-link v-else-if="$store.state.files.current_category.type == 2" :to="'/local/'+$store.state.files.current_category.url" class="bttn">{{$t("views.cart.add_more")}}</router-link>
        <router-link v-else-if="$store.state.files.current_category.type == 3" :to="'/comunicacion/'+$store.state.files.current_category.url" class="bttn">{{$t("views.cart.add_more")}}</router-link>
        <div class="bttn main" @click="confirm()" v-if="this.$store.getters['orders/getCartLength'] > 0">{{$t("views.cart.confirm")}}</div>
      </div>

    </div>

    <div class="fiscal-popup" v-if="LocationIncompleted">
      <div class="popup">
        <h1>{{$t("views.cart.popup.title", { name: LocationIncompleted.name })}}</h1>
        <v-container grid-list-xl>
          <v-layout row >
            <v-flex xs6>
              <v-text-field hide-details v-model="LocationIncompleted.cif" :class="{ 'empty': !LocationIncompleted.cif && showPopupErrors }" :label="$t('views.cart.popup.cif')" required></v-text-field>
              <br>
              <v-text-field hide-details v-model="LocationIncompleted.fiscal_address" :class="{ 'empty': !LocationIncompleted.fiscal_address && showPopupErrors }" :label="$t('views.cart.popup.fiscal_address')" required></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field hide-details v-model="LocationIncompleted.razon" :class="{ 'empty': !LocationIncompleted.razon && showPopupErrors }" :label="$t('views.cart.popup.razon')" required></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <div class="bttn" @click="cancelFiscalData()">{{$t("general.cancel")}}</div>
        <div class="bttn main" @click="confirmFiscalData()">{{$t("views.cart.popup.update")}}</div>
      </div>
    </div>
    

  </section>
</template> 

<script>
import i18n from '@/i18n';

export default {
  name: 'Cart',
  data () {
    return {
      // POPUP LOCATION INCOMPLETED FISCAL INFO
      LocationIncompleted: false,
      showPopupErrors: false,
      // GENERAL
      home: '/',
      contact: JSON.parse( JSON.stringify( this.$store.getters['user/getUser'] ) ),
      error_message : false,
      success_message : false,
      sizes: this.$store.getters['orders/getSizes'],
      questions: this.$store.getters['orders/getQuestions'],
      description: this.$store.getters['orders/getDescriptions'],
      orders: {},
      valid: false,
    }
  },
  computed: {
    locations() {
      return this.$store.getters['locations/getLocations']

    },
    market() {
      return this.$store.getters['getMarket']
    },

    // orders() {
    //   console.log( this.$store.getters['orders/getCart'] );
    //     return this.$store.getters['orders/getCart'];
    // }
  },
  methods: {
    remove(item) {

        // TODO - Show confirm popup
        console.log( item.id );
        this.$store.commit( 'orders/removeOrder', item.id + "" );
        this.orders = this.$store.getters['orders/getCart'];
    },
    confirm() {
      console.log(this.market)
      var errors = [];
      for( var key in this.orders ){
          var order = this.orders[ key ];
          if( order.method == 1 ){
              if( !order.billed && this.market == 'ES'){
                  errors.push( this.$t("views.cart.error.billed") );
              }
          }
          else if( order.method == 2 ){
              if( !order.units && !order.units_scale || ( order.units_scale == -1 && order.units_scale_custom.trim() == "" && !order.units ) ){
                  errors.push( this.$t("views.cart.error.units") );
              }
              if( !order.shipped || ( order.shipped == "-1" && order.custom_ship.trim() == "" ) ){
                  errors.push( this.$t("views.cart.error.shipped") );
              }
              if( !order.billed && this.market == 'ES'){
                  errors.push( this.$t("views.cart.error.billed") );
              }
          }
      }

      if( this.contact.name.trim() == "" ){
          errors.push( this.$t("views.cart.error.name") ); 
      }

      if ( this.contact.email.trim() == "" ){
        errors.push( this.$t("views.cart.error.email") );
      }
      else if (this.market == 'PT'){
        if( !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(this.contact.email.trim()) ){
            errors.push( this.$t("views.cart.error.corporate_email") );
        }
      } else if (this.market == 'ES'){
        if( !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(this.contact.email.trim()) ){
            errors.push( this.$t("views.cart.error.corporate_email") );
        }
      }

      if( this.contact.phone.trim() == "" && this.market == 'ES'){
          errors.push( this.$t("views.cart.error.phone") );
      }

      // this.error_message = "No has completado todos los campos";
      if( errors.length > 0 ){
          this.error_message = "";
          errors.forEach( error => {
              this.error_message += error + '<br>';
          });
      }
      else {
          var self = this;
          var cart = {
              contact: this.contact,
              items: this.orders
          };

          cart.contact.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id;

          // Set billed to -1 for all items if market is not ES
          if (this.market !== 'ES') {
            for (const key in cart.items) {
              cart.items[key].billed = -1;
            }
          }

          if( this.market == 'PT' ){
            var user = {
              phone: this.contact.phone,
              id: this.contact.id
            }
            this.$store.dispatch('user/addPhone', user)
              .then(() => {
                this.contact = JSON.parse(JSON.stringify(this.$store.getters['user/getUser']));
              });
          }

          this.$store.dispatch( 'orders/uploadCart', cart ).then( function(){
              self.success_message = true;
              self.error_message = false;
              self.orders = {};
              self.$router.push('/orders');
              self.$popup.alert( this.$t("views.cart.popup.success") );
          });
      }

    },
    edit(item) {
      this.$store.commit( 'orders/setCurrentOrder', item );
      this.$router.push( { name: 'order_edit', params: { id: item.id } } );
    },

    checkFiscalInfo(order, order_index) {
      var billedLocation = this.locations[order.billed];

      if (!billedLocation.razon || !billedLocation.cif || !billedLocation.fiscal_address ) {
        console.log(order_index)
        billedLocation.order_index = order_index
        this.LocationIncompleted = billedLocation;
      }
    },

    cancelFiscalData() {
      this.showPopupErrors = false;
      this.orders[this.LocationIncompleted.order_index].billed = '';
      this.LocationIncompleted = false;
    },

    confirmFiscalData() {
      if ( !this.LocationIncompleted.razon || !this.LocationIncompleted.cif || !this.LocationIncompleted.fiscal_address ) {
        this.showPopupErrors = true;
      } else {
        var self = this;
        this.$store.dispatch( 'locations/uploadRestaurant', this.LocationIncompleted ).then( function(){
          self.showPopupErrors = false;
          self.LocationIncompleted = false;
        });
      }
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    }
  },
  created() {
    this.$store.commit('setTitle', 'Confirmación pedidos');
    this.$store.commit('setMenuVisible', false);

    var orders = JSON.parse( JSON.stringify ( this.$store.getters['orders/getCart'] ) );
    this.orders = orders;

  },
  watch: {
    orders: {
      handler(val){
        localStorage.setItem( 'cart', JSON.stringify( this.orders ) );
        this.$store.dispatch( 'orders/loadCart' );
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .title {
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 12pt;
  }


  .main-content {
    width: 80%;
    margin: 0 auto;
    margin-top: 35px;

    .subtitle {
      text-align: left;
      text-transform: uppercase;
      font-size: 16px;
    }

   .list {
    width: 100%;
    margin-bottom: 50px;

    .empty {
      background: #eee;
      padding: 15px;
      border-radius: 5px;
      color: #888;
    }

    .item {
      width: 100%;
      display: block;
      padding: 20px 10px;
      border-bottom: 1px solid #ccc;
      overflow: hidden;
      text-align: left;

      .info-order {
         float: left;
         width: 200px;
      }
          .image {
            width: 100%;
            float: left;
            padding: 5px;
          }
      .content {
        width: calc( 100% - 300px );
        float: left;
        padding: 5px 15px;

        .to {
          margin-bottom: 15px;

          .name {
            font-family: Speedee-Bold;

            .print {
              background: var(--main_color);
              padding: 3px 10px;
              border-radius: 15px;
              font-size: 10px;
              margin-left: 10px;
            }
          }
          .size {
            font-size: 13px;

          }
        }
        .param {
          margin-bottom: 5px;
          overflow: hidden;

          &.info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            background: none !important;
            border: none !important;

            .direction {
              display: flex;
              align-items: center;
              gap: 5px;
            }
          }

          .label {
            font-size: 12px;
            color: #999;
            float: left;
            width: 150px;
            line-height: 30px;
          }
          .container {
            float: left;
            width: calc( 100% - 150px );
            padding: 0;

            input, select {
              border-radius: 3px;
              border: 1px solid #ccc;
              padding: 5px;
            }
            input {
              padding: 7px;
            }
            .address {
              min-width: 400px;
              clear: both;
              margin-top: 5px;
              display: block;
            }
            .single {
              padding: 5px;
              margin-left: 15px;
              width: 100px; margin-right: 5px;
            }
          }
          &.units {
            input {
              width: 50px;
            }
          }
        }

      }
      .actions {
        width: 100px;
        float: left;
        padding-top: 20px;

        .bttn {
          background-position: left center;
          background-repeat: no-repeat;
          background-size: 16px;
          padding: 5px;
          padding-left: 25px;
          font-size: 14px;
          cursor: pointer;

          &.edit {
            background-image: url('/img/edit-b.svg');

          }
          &.remove {
            background-image: url('/img/remove.svg');
          }

          &:hover {
            text-decoration: underline;
          }

        }
      }
    }
   }

   .contact {
    text-align: left;
    margin-bottom: 25px;
    overflow: hidden;

    .param {
      margin-bottom: 5px;
      overflow: hidden;

      .label {
        font-size: 12px;
        color: #999;
        float: left;
        width: 100px;
        line-height: 30px;
      }

      input, select {
        border-radius: 3px;
        border: 1px solid #ccc;
        padding: 5px;
        min-width: 300px;
      }
      input {
        padding: 7px;
      }
      
   }
 }

   .buttons {
    margin: 40px auto;

    .bttn {
      width: 250px;
      display: inline-block;
      border-radius: 3px;
      padding: 15px;
      cursor: pointer;
      background-color: #eee;
      margin: 0 10px;
      color: var(--dark_color);
      text-decoration: none;

      &.main {
        background-color: var(--main_color);
        color: #000;
        font-family: Speedee-Bold;
        text-transform: uppercase;
      }
    }
   }

  }



  .fiscal-popup {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
    z-index: 10;
    overflow: hidden;
    top: 0;
    left: 0;

    .empty {
      border: 1px solid red;
    }

    .popup {
      padding: 20px 10px;
      width: 80%;
      height: auto;
      position: fixed;
      z-index: 10;
      bottom: calc(50% - 110px);
      left: 10%;
      background-color: #fff;
      border-radius: 4px;

      .bttn {
        display: inline-block;
        padding: 10px 15px;
        margin: 0 10px;
        cursor: pointer;
        background-color: rgba(0,0,0,0.8);
        color: white;
        border-radius: 4px;

        &.main {
          background-color: var(--main_color);
          color: #000;
        }
      }
      
    }
  }


</style>
